export function formatCamelCase(text: string): string {
    return text
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase())
        .trim();
}

/**
 * Turn a raw snake_case key into a human-readable label,
 * e.g. `inspection_zone` → "Inspection Zone".
 */
export function humanizeSnakeCase(key: string): string {
    return key
        .split('_')
        .filter(Boolean)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' ');
}
